import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
import { TIPOS } from './estacionamientoLogic';
import { MonogramaSura, MarcaGer, MarcaP } from './Emblemas';

// Contenido del puesto segun su tipo. En gerencia el logo va con el sello G (Gerencia):
// la fila inferior lleva el numero abajo, asi que el sello va arriba del logo; en la superior es al reves.
function Cuerpo({ tipo, fila }) {
  if (tipo === 'libre') return <MarcaP size={32} />;
  if (tipo === 'privado_sura') return <MonogramaSura alto={48} />;
  if (tipo === 'gerencia') {
    const logo = <MonogramaSura key="logo" alto={28} />;
    const sello = <MarcaGer key="sello" alto={26} />;
    return fila === 'superior' ? [logo, sello] : [sello, logo];
  }
  return (
    <>
      <Lock size={20} color="#132752" strokeWidth={2.4} aria-hidden="true" />
      <span className="est-tag">Privado</span>
    </>
  );
}

export default function Puesto({
  numero, tipo, fila, left, top, ancho, alto, retraso, sinMovimiento,
  bloqueado, atenuado, resaltado, activo, seleccionado, edicion,
  onEnter, onLeave, onFoco, onDesenfoque, onPulsar,
}) {
  const etiqueta = TIPOS[tipo] ? TIPOS[tipo].etiqueta : tipo;
  const clases = [
    'est-puesto',
    `est-tipo-${tipo}`,
    `est-fila-${fila}`,
    bloqueado ? 'est-bloqueado' : '',
    atenuado ? 'est-atenuado' : '',
    resaltado ? 'est-resaltado' : '',
    activo ? 'est-activo' : '',
  ].filter(Boolean).join(' ');

  // Solo el foco de teclado alimenta el panel de detalle; el clic con raton ya usa la seleccion.
  const alEnfocar = (e) => {
    let visible = true;
    try { visible = e.currentTarget.matches(':focus-visible'); } catch (err) { visible = true; }
    if (visible) onFoco(numero);
  };

  const numeroEl = <span className="est-num">{numero}</span>;
  const cuerpoEl = (
    <span className="est-cuerpo">
      <Cuerpo tipo={tipo} fila={fila} />
    </span>
  );

  return (
    <motion.div
      className={`est-celda${activo || seleccionado ? ' est-celda-viva' : ''}`}
      style={{ left, top, width: ancho, height: alto }}
      initial={sinMovimiento ? false : { opacity: 0, y: 16, scale: 0.94 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.4, delay: retraso, ease: [0.22, 1, 0.36, 1] }}
    >
      <button
        type="button"
        className={clases}
        data-puesto={numero}
        aria-label={`Puesto ${numero}, ${etiqueta}${bloqueado ? ', no disponible' : ''}`}
        aria-pressed={Boolean(seleccionado)}
        aria-haspopup={edicion ? 'dialog' : undefined}
        title={bloqueado ? 'Solo gerencia' : undefined}
        onPointerEnter={(e) => { if (e.pointerType === 'mouse') onEnter(numero); }}
        onPointerLeave={(e) => { if (e.pointerType === 'mouse') onLeave(numero); }}
        onFocus={alEnfocar}
        onBlur={() => onDesenfoque(numero)}
        onClick={() => onPulsar(numero)}
      >
        {fila === 'superior' ? numeroEl : cuerpoEl}
        {fila === 'superior' ? cuerpoEl : numeroEl}
      </button>
    </motion.div>
  );
}
